export default __webpack_public_path__ + "static/media/externalLinkContrast.090916be.svg";